import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { Subscription, Subject } from 'rxjs';
import { SharedService } from '../../services/shared.service';
import { LayoutService } from '../../services/layout.service';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Location } from '@angular/common';

@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: ['./main-menu.component.scss']
})
export class MainMenuComponent implements OnInit , OnDestroy {
  overlay: boolean = false;
  isExpand: boolean = true;
  selectedItem: any;
  isDashboard: any
  appTitle: string = "";
  hidePan: boolean = false;
  innerWidth: any;
  restrictView:boolean;
  forRestrictView: boolean;
  hidMnu: boolean;
  appExpand: string = "Menu";
  windowSize: number = 767;
  subscription: Subscription;
  componentDestroyed$: Subject<boolean> = new Subject();
  updateProfile;
  subscriptionLogin;
  menuItems: Array<Object> = [
    { name: 'Home', icon: 'home', link: '/dashboard', source: 'mat' },
    { name: 'QR Codes', icon: 'select_all', link: '/bulk-activation', source: 'mat' },
    // { name: 'Communication', icon: 'communicationnav', link: '/administration',source:'custom' },
    //{ name: 'Settings', icon: 'configure', link: '/setting', source: 'custom' },
    //{ name: 'Help', icon: 'help_outline', link: '/faq', source: 'mat' },
  ];

  constructor(
    private sharedService: SharedService, 
    private location: Location, 
    private dataService: LayoutService, 
    private router: Router, 
    private auth: AuthService) {
    this.onResize();
  }
  ngOnInit() {
    if (this.dataService.userRoleData) {
      this.hidMnu = this.sharedService.IsRoleAccess('Administration Menu', 'Access to Administration Menu', 'Access');
    } else {
      this.subscription = this.dataService.getRoleValueAccess.asObservable().subscribe(res => {
        this.hidMnu = this.sharedService.IsRoleAccess('Administration Menu', 'Access to Administration Menu', 'Access');
        this.subscription.unsubscribe();
      })
    }
    //Commented to show "QR Codes" tab everytime
    // if (!this.hidMnu && this.hidMnu != undefined) {
    //   this.menuItems.splice(1, 1);
    // }

    this.dataService.currentExpantValue.pipe(takeUntil(this.componentDestroyed$)).subscribe(data => {
      this.isExpand = data;
    })
    this.dataService.mainMenuView$.pipe(takeUntil(this.componentDestroyed$)).subscribe((data) => {
      this.forRestrictView = data;
    });
    this.dataService.currentMainMenuValue.pipe(takeUntil(this.componentDestroyed$)).subscribe((data: any) => {
      //this.appTitle = localStorage.getItem('Application')
      if (Object.keys(data).length > 0) {
        this.isDashboard = data.mainView;
        //this.appExpand = 'Menu - '+this.appTitle;
      }
    })
  }
  getUserType() {
    this.updateProfile = this.dataService.reloadProfile$.subscribe(data1 => {
      this.restrictView = data1;
      this.subscriptionLogin = this.dataService.getProfileData$.subscribe(data => {
        if (Object.keys(data).length) {
          if (data.healthPlusRoleId != '5de0138f9952be3f746353af' && data.healthPlusRoleId != '5de014189952be3f746353b2' && this.restrictView) {
            if (this.menuItems.length == 4) {
              this.menuItems.splice(2, 1);
            } else {
              this.menuItems.splice(1, 1);
            }
          }
        }
      });
    })
  }
  onChangeSideNav() {
    if (!this.forRestrictView) {
      this.isExpand = !this.isExpand;
      this.dataService.changeExpandValue(this.isExpand)
    } else {
      this.location.back();
    }
  }
  enableView() {
    if (!this.overlay) {
      this.overlay = true
    } else {
      this.overlay = false
    }
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.innerWidth = window.innerWidth;

  }
  ngOnDestroy() {
    this.componentDestroyed$.next(true);
    this.componentDestroyed$.complete();
  }
}
